// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import NewCard from '../../../components/NewCard';
import { CardTypes } from '../../../types/Model';
import { ProductCard } from '../../../components/NewCard/types';
import { S } from '../styles';

interface CardListProps {
  list: ProductCard[];
}

const CardList = ({ list }: CardListProps):JSX.Element => {
  return (
    <div style={{ position: 'relative' }}>
      <S.ListWrapper>
        {list.map((value:ProductCard, index) => {
          switch (value.type) {
            case CardTypes.COURSE:
              return (
                <NewCard
                  key={index}
                  id={value.id}
                  type={value.type}
                  name={value.name}
                  domainIds={value.domainIds}
                  totalDuration={value.totalDuration}
                  levelId={value.levelId}
                  platformId={value.platformId}
                  imageUrl={value.imageUrl}
                  language={value.language}
                  vodCount={value.vodCount}
                  labCount={value.labCount}
                  examCount={value.examCount}
                  challengeCount={value.challengeCount}
                  assessmentCount={value.assessmentCount}
                  completionProgress={value.completionProgress}
                  isOwner={value.isOwner}
                />
              )
            case CardTypes.WORKSHOP:
              return (
                <NewCard
                  key={index}
                  id={value.id}
                  type={value.type}
                  name={value.name}
                  domainIds={value.domainIds}
                  totalDuration={value.totalDuration}
                  levelId={value.levelId}
                  platformId={value.platformId}
                  imageUrl={value.imageUrl}
                  language={value.language}
                  vodCount={value.vodCount}
                  labCount={value.labCount}
                  challengeCount={value.challengeCount}
                  assessmentCount={value.assessmentCount}
                  examCount={value.examCount}
                  completionProgress={value.completionProgress}
                  startTime={value.startTime}
                  endTime={value.endTime}
                  isOwner={value.isOwner}
                />
              )
            case CardTypes.ILTCOURSE:
              return (
                <NewCard
                  key={index}
                  id={value.id}
                  type={value.type}
                  name={value.name}
                  domainIds={value.domainIds}
                  levelId={value.levelId}
                  platformId={value.platformId}
                  totalDuration={value.totalDuration}
                  imageUrl={value.imageUrl}
                  language={value.language}
                  location={value.location}
                  vodCount={value.vodCount}
                  labCount={value.labCount}
                  examCount={value.examCount}
                  challengeCount={value.challengeCount}
                  assessmentCount={value.assessmentCount}
                  completionProgress={value.completionProgress}
                  isOwner={value.isOwner}
                  startTime={value.startTime}
                  endTime={value.endTime}
                />
              )
            // 我的學習只顯示 course/workshop
            // case CardTypes.LAB:
            //   return (
            //     <NewCard
            //       key={index}
            //       id={value.id}
            //       type={value.type}
            //       name={value.name}
            //       domainIds={value.domainIds}
            //       totalDuration={value.totalDuration}
            //       levelId={value.levelId}
            //       platformId={value.platformId}
            //       imageUrl={value.imageUrl}
            //       language={value.language}
            //     />
            //   )
            // case CardTypes.CHALLENGE:
            //   return (
            //     <NewCard
            //       key={index}
            //       id={value.id}
            //       type={value.type}
            //       name={value.name}
            //       domainIds={value.domainIds}
            //       totalDuration={value.totalDuration}
            //       levelId={value.levelId}
            //       platformId={value.platformId}
            //       imageUrl={value.imageUrl}
            //       language={value.language}
            //     />
            //   )
            // case CardTypes.EXAM:
            //   return (
            //     <NewCard
            //       key={index}
            //       id={value.id}
            //       type={value.type}
            //       name={value.name}
            //       domainIds={value.domainIds}
            //       totalDuration={value.totalDuration}
            //       levelId={value.levelId}
            //       platformId={value.platformId}
            //       imageUrl={value.imageUrl}
            //       language={value.language}
            //       multiSelect={value.multiSelect}
            //       qna={value.qna}
            //     />
            //   )
            default:
              return null;
          }
        })}
      </S.ListWrapper>
    </div>
  );
};

export { CardList as default };
